var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChair(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M20,7h-1V3c0-1.654-1.346-3-3-3H8c-1.654,0-3,1.346-3,3V7h-1c-1.654,0-3,1.346-3,3v9H11v3H6v2h12v-2h-5v-3h10V10c0-1.654-1.346-3-3-3Zm0,2c.551,0,1,.448,1,1v3.172c-.313-.111-.649-.172-1-.172h-1v-4h1ZM8,2h8c.551,0,1,.448,1,1V13H7V3c0-.552,.449-1,1-1Zm-4,7h1v4h-1c-.351,0-.687,.061-1,.172v-3.172c0-.552,.449-1,1-1Zm17,8H3v-1c0-.552,.449-1,1-1H20c.551,0,1,.448,1,1v1Z",
    fill: "#9bd4ed",
    "data-original": "#000000"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChair);
export default __webpack_public_path__ + "static/media/chair.0217cd6775502c7367c4bc6ce7c191d4.svg";
export { ForwardRef as ReactComponent };